export default __webpack_public_path__ + "static/media/arts-pom.3bbbd42b.jpg";